import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    width: "90vw",
  },
  quote: {
    width: "100%",
    padding: 0,
  },
  quoteContent: {
    padding: 0,
  },
  containerTasks: {
    textAlign: "left",
    width: "230px",
  },
  button: {
    cursor: "pointer",
  },
  quoteList: {
    width: "100%",
  },
}));

export default styles;
